import React from 'react'
import Navbar from '../components/Navbar'
import Home from './Home'
import OurBrands from '../components/OurBrands'
import Aboutus from './Aboutus'
import OurCars from './OurCars'
import WhyChooseUs from './WhyChooseUs'
import ContactUs from './ContactUs'
import Footer from '../components/Footer'
import RentACarSection from './RentACarSection'
import FloatingIcons from '../components/FloatingIcons'

const Main = () => {
  return (
    <>
    <Navbar/>
    <Home/>
    <OurBrands/>
    <OurCars/>
    <Aboutus/>
    <WhyChooseUs/>
    <RentACarSection/>
    <ContactUs/>
    <Footer/>

    {/* Floating Social Icons */}
      <FloatingIcons />
    </>
  )
}

export default Main